"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dailyOrUnAggregatedOnlyAggregationIntervalHelper = exports.hourlyOrUnaggregatedOnlyAggregationIntervalHelper = exports.dailyOrHourlyOnlyAggregationIntervalHelper = exports.unaggregatedOnlyAggregationIntervalHelper = exports.hourlyOnlyAggregationIntervalHelper = exports.dailyOnlyAggregationIntervalHelper = exports.defaultAggregationIntervalHelper = void 0;
const app_platform_values_helpers_and_types_1 = require("@semios/app-platform-values-helpers-and-types");
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const aggregationsByHours = (hours) => {
    const allowed = ['DAILY'];
    const hourlyThreshold = app_platform_values_helpers_and_types_1.hourThresholdForAggregations.HOURLY;
    if (hours < hourlyThreshold)
        allowed.push('HOURLY');
    if (hours < app_platform_values_helpers_and_types_1.hourThresholdForAggregations.UNAGGREGATED)
        allowed.push('UNAGGREGATED');
    return allowed;
};
const includesInterval = (intervals, interval) => {
    return intervals.includes(interval);
};
// DAILY, HOURLY, UNAGGREGATED
const defaultAggregationIntervalHelper = (requestedInterval, dateFrom, dateTo) => {
    const hourDifference = moment_timezone_1.default.tz(dateTo, 'utc').diff(moment_timezone_1.default.tz(dateFrom, 'utc'), 'hours');
    const aggsAllowed = aggregationsByHours(hourDifference);
    if (includesInterval(aggsAllowed, requestedInterval)) {
        return requestedInterval;
    }
    // otherwise get the smallest aggregation that is allowed
    return aggsAllowed.pop();
};
exports.defaultAggregationIntervalHelper = defaultAggregationIntervalHelper;
const dailyOnlyAggregationIntervalHelper = () => 'DAILY';
exports.dailyOnlyAggregationIntervalHelper = dailyOnlyAggregationIntervalHelper;
const hourlyOnlyAggregationIntervalHelper = () => 'HOURLY';
exports.hourlyOnlyAggregationIntervalHelper = hourlyOnlyAggregationIntervalHelper;
const unaggregatedOnlyAggregationIntervalHelper = () => 'UNAGGREGATED';
exports.unaggregatedOnlyAggregationIntervalHelper = unaggregatedOnlyAggregationIntervalHelper;
const dailyOrHourlyOnlyAggregationIntervalHelper = (requestedInterval, dateFrom, dateTo) => {
    const hourDifference = moment_timezone_1.default.tz(dateTo, 'utc').diff(moment_timezone_1.default.tz(dateFrom, 'utc'), 'hours');
    const aggsAllowed = aggregationsByHours(hourDifference).filter((a) => a !== 'UNAGGREGATED');
    if (includesInterval(aggsAllowed, requestedInterval)) {
        return requestedInterval;
    }
    // otherwise get the smallest aggregation that is allowed
    return aggsAllowed.pop();
};
exports.dailyOrHourlyOnlyAggregationIntervalHelper = dailyOrHourlyOnlyAggregationIntervalHelper;
const hourlyOrUnaggregatedOnlyAggregationIntervalHelper = (requestedInterval, dateFrom, dateTo) => {
    const hourDifference = moment_timezone_1.default.tz(dateTo, 'utc').diff(moment_timezone_1.default.tz(dateFrom, 'utc'), 'hours');
    const aggsAllowed = aggregationsByHours(hourDifference).filter((a) => a !== 'DAILY');
    if (aggsAllowed.includes(requestedInterval)) {
        return requestedInterval;
    }
    return aggsAllowed.pop();
};
exports.hourlyOrUnaggregatedOnlyAggregationIntervalHelper = hourlyOrUnaggregatedOnlyAggregationIntervalHelper;
const dailyOrUnAggregatedOnlyAggregationIntervalHelper = (requestedInterval, dateFrom, dateTo) => {
    const hourDifference = moment_timezone_1.default.tz(dateTo, 'utc').diff(moment_timezone_1.default.tz(dateFrom, 'utc'), 'hours');
    const aggsAllowed = aggregationsByHours(hourDifference).filter((a) => a !== 'HOURLY');
    if (includesInterval(aggsAllowed, requestedInterval)) {
        return requestedInterval;
    }
    // otherwise get the smallest aggregation that is allowed
    return aggsAllowed.pop();
};
exports.dailyOrUnAggregatedOnlyAggregationIntervalHelper = dailyOrUnAggregatedOnlyAggregationIntervalHelper;
//# sourceMappingURL=_aggregation_helpers.js.map